import React, { useCallback, useEffect, useState } from "react";
import "./LayoutAdmin.scss";
import TopHeader from "../../../components/TopHeader/TopHeader";
import Sidebar from "../../../components/Sidebar/Sidebar";
import { Outlet } from "react-router-dom";

export interface DashboardContextType {
  isHistoryOpen: boolean;
  toggleHistory: () => void;
}

const LayoutAdmin = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(true);
  const [isHistoryOpen, setIsHistoryOpen] = useState(true);

  const toggleMenu = useCallback(() => {
    setIsMenuOpen(prevState => !prevState);
  }, []);

  const toggleHistory = useCallback(() => {
    setIsHistoryOpen(prevState => !prevState);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 991) {
        setIsMenuOpen(false); 
        setIsHistoryOpen(false); 
      } else {
        setIsMenuOpen(true);
        setIsHistoryOpen(true);
      }
    };
    handleResize();

    // Add resize event listener
    window.addEventListener('resize', handleResize);

    // Clean up the event listener on unmount
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  return (
    <>
       <div className="dashboard-wrapper">
      <TopHeader onMenuToggle={toggleMenu} onHistoryToggle={toggleHistory} />
      <div className="dashboard-main-content-wrap">
        <Sidebar isMenuOpen={isMenuOpen} onMenuToggle={toggleMenu} />
        
        {/* This Outlet will render nested route components */}
        <Outlet context={{isHistoryOpen , toggleHistory}}/>
      </div>
    </div>
    </>
  );
};

export default LayoutAdmin;
